<div class="content">
  <div class="login">
    <div class="login-logo-odm">
      <img src="{{logoPath}}">
    </div>
    <form (ngSubmit)="sendEmail(forgetPasswordForm)" #forgetPasswordForm="ngForm">
      <div class="login-content">
        <h3><span translate>Forget your password?</span>We will send password reset instructions to the email address associated with your PowerMaster account.</h3>
        <div class="form-group">
          <label for="" class="col-form-label" translate>E-mail</label>
          <div>
            <input type="text" pInputText class="pInputText" [(ngModel)]="loginEmail" name="loginEmail" required
              pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" #emailAccount="ngModel">
            <p-message severity="error" text="{{'Email is invalid' | translate}}" *ngIf="(forgetPasswordForm.submitted && !emailAccount.dirty) || (emailAccount.invalid && (emailAccount.dirty || emailAccount.touched))"></p-message>
          </div>
        </div>
        <ng-container *ngIf="recaptcha.render">
<!--          <re-captcha siteKey="6LelXNYZAAAAAJ5830oP9rdWaOxCxVQuTrSta9si"></re-captcha>-->
          <p-captcha siteKey="6LelXNYZAAAAAJ5830oP9rdWaOxCxVQuTrSta9si"></p-captcha>
          <p-message severity="error" text="Captcha code provided is incorrect." *ngIf="captchaError"></p-message>
        </ng-container>
        <button type="submit" pButton label="{{'SEND RESET INSTRUCTIONS' | translate}}" class="login-btn" name="submit"></button>
      </div>
    </form>
  </div>
</div>

<!-- Reset password 成功 -->
<p-dialog header="Information" [(visible)]="displayResetDialog.success" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <h5 translate>E-mail has been sent.</h5>
    <p translate> Please check your email account to reset password.</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="closeDialog();" label="{{'OK' | translate}}" class="login-btn"></button>
  </ng-template>
</p-dialog>

<!-- Reset password 失敗 -->
<p-dialog header="Information" [(visible)]="displayResetDialog.fail" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p translate>Reset password failed</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="closeDialog();" label="{{'OK' | translate}}" class="login-btn"></button>
  </ng-template>
</p-dialog>

